<template>
  <div id="mb-media-bar">
    <transition name="media-bar-fade">
      <div class="media-bar" v-if="mediaState">
        <div
          class="media-bar-img-box"
          :class="{
            'media-disable': media.disable,
          }"
          @click="openUrl(media.href, media.disable)"
          :key="'media-bar-img-box-' + indexMedia"
          v-for="(media, indexMedia) in mediaBarObj.media"
        >
          <img class="media-bar-img" :src="media.img" />
        </div>
      </div>
    </transition>
    <div
      class="media-bar-button"
      v-if="mediaBarObj"
      @click="mediaState = !mediaState"
      @mouseenter="hoverState = true"
      @mouseleave="hoverState = false"
    >
      <!-- <svg width="100%" height="100%" viewBox="0 0 100 100">
        <path stroke-width="0" fill="white" :d="setPath()" style="transition: .5s" />
      </svg>-->
      <img v-if="!hoverState && !mediaState && mediaIcon" :src="mediaIcon" />
      <img v-if="(hoverState || mediaState) && mediaIconON" :src="mediaIconON" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'mb-media-bar',
  props: {
    mediaData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {},
  data: function () {
    return {
      hoverState: false,
      mediaBarObj: null,
      mediaState: false,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  beforeMount() {
    this.init();
  },
  methods: {
    openUrl(link, disable) {
      if (!disable) {
        if (link) {
          if (this.$store.getters.isWeb) {
            window.open(link, '_blank');
          } else {
            this.$electron.shell.openExternal(link);
          }
        }
      }
    },
    setPath() {
      if (this.mediaState) {
        return 'M 75 20, 20 50, 75 80Z';
      } else {
        return 'M 75 50, 25 20, 25 80Z';
      }
    },
    init() {
      // this.mediaBarObj = {
      //   mediaBar: this.mediaData.mediaBar,
      //   media: this.mediaData.media,
      // };
      if (this.mediaBarConf) {
        this.mediaBarObj = {
          mediaBar: true,
          media: this.mediaBarConf,
        };
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    mediaBarConf() {
      try {
        return require(`__mainSrcDir/config/homePage/grid/media/media.config.js`).default;
      } catch {
        console.log(
          '%cMediaBarConfig MbMediaBar- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    mediaIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/mediaBar/media-bar-36px.png`);
      } catch {
        console.log(
          '%cMediaBarIcon MbMediaBar- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    mediaIconON() {
      try {
        return require(`__mainSrcDir/assets/icons/mediaBar/media-bar-ON-36px.png`);
      } catch {
        console.log(
          '%cMediaBarIconOn MbMediaBar- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
$break-large: 1400px
.media-bar-button, .media-bar
  position: absolute
  width: 5vmin
  height: 6vmin
  border-radius: 0 1em 1em 0
  cursor: pointer
  // background: #004899
  bottom: 1.56vmax
  left: 0%
  // opacity: .5
  z-index: 4
  transition: .5s
  display: flex
  align-items: center
  justify-content: center
  // &:hover
    // opacity: 1
  img
    width: 1.8vmax
    height: 1.8vmax
.media-bar
  cursor: auto !important
  bottom: calc(1.56vmax - 0.5vmin)
  left: 3%
  z-index: 10
  width: 45%
  height: 7vmin
  border-radius: 1em 1em 1em 1em
  cursor: pointer
  background: white
  opacity: 1
  display: flex
  align-items: center
  justify-content: center
  box-shadow: 0px 0px 5px 1px gray
  // padding-left: 2%
  .media-disable
    transform: scale(.9) !important
    cursor: auto !important
    img
      filter: grayscale(80%)
  .media-bar-img-box
    margin: 0% 1.5%
    width: 22%
    cursor: pointer
    transition: .5s
    transform: scale(.9)
    .media-bar-img
      width: 100%
      height: 100%
      object-fit: scale-down
    &:hover
      transform: scale(1)

.media-bar-fade-leave-active, .media-bar-fade-enter-active
  transition: all .5s ease-in-out
.media-bar-fade-leave-to, .media-bar-fade-enter
  transform: translateX(-110%)
  opacity: 0
</style>
